import React, { memo } from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const FlashBoxIcon = ({
  height = normalize(40),
  width = normalize(40),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 40 40"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4V36C0 38.2091 1.79086 40 4 40H36C38.2091 40 40 38.2091 40 36V4C40 1.79086 38.2091 0 36 0H4ZM23.7038 18.4376C23.8603 18.4376 24.0066 18.5217 24.0918 18.6633C24.1779 18.8038 24.1899 18.9799 24.127 19.1333L20.4232 28.0394C20.3473 28.2215 20.1797 28.3333 20.0001 28.3333C19.9686 28.3333 19.9362 28.3294 19.9038 28.3224C19.6899 28.274 19.5371 28.0721 19.5371 27.8385V22.3959H16.2963C16.1398 22.3959 15.9935 22.3108 15.9083 22.1703C15.8232 22.0308 15.8093 21.8526 15.8732 21.7002L19.5769 12.7941C19.6658 12.5814 19.8788 12.4616 20.0964 12.5111C20.3102 12.5596 20.463 12.7615 20.463 12.995V18.4376H23.7038Z"
      fill={color}
    />
  </Svg>
);

export default memo(FlashBoxIcon);
